module.exports = __webpack_public_path__ + "img/제품이동교통.2be5292c.png";